import { createContext, useContext } from 'react';
import { type CustomDomainState } from './CustomDomainState';

export const CustomDomainContext = createContext<CustomDomainState>({ kind: 'unavailable' });

export function useCustomDomain(): CustomDomainState {
    return useContext(CustomDomainContext);
}

export function useCustomDomainName(): string | undefined {
    const state = useCustomDomain();
    return state.kind === 'loaded' ? state.branding.domain : undefined;
}
